import type { LeanCustomsDeclarationDocument } from "../services/leancustomsService";

export function isUtbDeclarationDocument(
  doc: LeanCustomsDeclarationDocument
): boolean {
  const type = String(doc.document_type ?? "").toLowerCase();
  const name = String(doc.filename ?? "").toLowerCase();
  return type.includes("utb") || name.includes("utb");
}

export function isTtwDeclarationDocument(
  doc: LeanCustomsDeclarationDocument
): boolean {
  const type = String(doc.document_type ?? "").toLowerCase();
  const name = String(doc.filename ?? "").toLowerCase();
  return type.includes("ttw") || name.includes("ttw");
}

/** UTB first, then TTW, then other documents; preserve order within each group. */
export function sortDeclarationDocumentsUtbFirst(
  docs: LeanCustomsDeclarationDocument[]
): LeanCustomsDeclarationDocument[] {
  const priority = (doc: LeanCustomsDeclarationDocument): number => {
    if (isUtbDeclarationDocument(doc)) return 0;
    if (isTtwDeclarationDocument(doc)) return 1;
    return 2;
  };
  return [...docs].sort((a, b) => {
    const pa = priority(a);
    const pb = priority(b);
    if (pa !== pb) return pa - pb;
    return 0;
  });
}

/** Official declaration output kind shown as a blue tag on the booking view. */
export function getDeclarationDocumentOfficialKind(
  doc: LeanCustomsDeclarationDocument
): "utb" | "ttw" | null {
  if (isUtbDeclarationDocument(doc)) return "utb";
  if (isTtwDeclarationDocument(doc)) return "ttw";
  return null;
}

/** True when the declaration document list includes at least one UTB and one TTW. */
export function hasUtbAndTtwDocuments(
  docs: LeanCustomsDeclarationDocument[]
): boolean {
  let hasUtb = false;
  let hasTtw = false;
  for (const doc of docs) {
    if (isUtbDeclarationDocument(doc)) hasUtb = true;
    if (isTtwDeclarationDocument(doc)) hasTtw = true;
    if (hasUtb && hasTtw) return true;
  }
  return false;
}
